export interface BlockFileEntry {
	index: number;
	type: "image" | "video";
	file: File;
}

export interface AnnouncementFormValues {
	notificationType: "announcement" | "push";
	title: string;
	body: string;
	/** Blob reference returned by the upload pipeline (null when no image set). */
	heroImage: string | null;
	pushTitle: string;
	pushBody: string;
	audienceType: "everyone" | "platform" | "groups" | "users";
	audiencePlatform: "ios" | "android" | "both";
	audienceUserIds: string[];
	audienceGroupIds: number[];
	hasSchedule: boolean;
	scheduledDate: string;
	scheduledTime: string;
	hasExpiry: boolean;
	expiryDate: string;
	expiryTime: string;
	blockFiles: BlockFileEntry[];
	contentBlocks: MeeAnnouncementContentBlock[];
}

export function formValuesToAnnouncement(
	data: AnnouncementFormValues,
	id?: number
): Partial<MeeAnnouncement> {
	// hasSchedule is the source of truth for "is this scheduled?" — the
	// date/time inputs are hidden until the checkbox is on, and unchecking
	// clears them, so this gate also reflects the visible UI state.
	const scheduledAt =
		data.hasSchedule && data.scheduledDate
			? `${data.scheduledDate}T${data.scheduledTime || "00:00"}:00`
			: null;

	const expiresAt =
		data.hasExpiry && data.expiryDate
			? `${data.expiryDate}T${data.expiryTime || "00:00"}:00`
			: null;

	return {
		...(id !== undefined && { id }),
		title: data.title,
		body: data.body || null,
		pushTitle: data.pushTitle || null,
		pushBody: data.pushBody || null,
		audienceType: data.audienceType,
		audiencePlatform:
			data.audienceType === "platform" ? data.audiencePlatform : null,
		audienceUserIds: data.audienceType === "users" ? data.audienceUserIds : [],
		audienceGroupIds:
			data.audienceType === "groups" ? data.audienceGroupIds : [],
		contentBlocks: data.contentBlocks,
		scheduledAt,
		expiresAt
	};
}
